import { configure, extend } from 'vee-validate';
import { confirmed, email, required } from 'vee-validate/dist/rules';
import * as rules from 'vee-validate/dist/rules';

import { normalizePhone } from '@/shared/helpers';

import i18n from '../plugins/i18n/i18n';
import storage from './storage';

const regularExpressions: {[index: string]: RegExp} = {
	allowedPasswordCharacters: /^[a-zA-Z\d!@#$%^~&*()\-+=\\\[\]{}:;<>|.\/?,_]+$/,
	specialChar: /[!@#$%^~&*()\-+=\\\[\]{}:;<>|.\/?,_]/,
	bigLetter: /[A-Z]/,
	smallLetter: /[a-z]/,
	alpha: /[a-z]/i,
	number: /\d/
};

export { regularExpressions };

export const validationRules = {
	init() {
		for (let [rule, validation] of Object.entries(rules)) {
			extend(rule, {
				...validation
			});
		}
		extend('min', {
			validate(value, args) {
				return value.length >= args.length;
			},
			params: ['length'],
			message: i18n.t('message.createAccount.minLengthError') as string
		});
		extend('max', {
			validate(value, args) {
				return value.length <= args.length;
			},
			params: ['length'],
			message: i18n.t('message.createAccount.maxLengthError') as string
		});
		extend('required', {
			...required,
			message: i18n.t('message.createAccount.mandatoryField') as string
		});
		extend('confirmed', {
			...confirmed,
			message: i18n.t('message.createAccount.confirmed') as string
		});
		extend('email', {
			...email,
			message: i18n.t('message.createAccount.wrongEmail') as string
		});
		extend('passwordUserName', (value: string): boolean | string => {
			value = value.toLowerCase();
			const userState = storage.getItem('user');
			const firstNameMatch = value.match(userState.firstName.toLowerCase());
			const lastNameMatch = value.match(userState.lastName.toLowerCase());

			if (!(firstNameMatch && firstNameMatch[0].length === userState.firstName.length || lastNameMatch && lastNameMatch[0].length == userState.lastName.length))
				return true;

			return i18n.t('message.changePassword.usernameError') as string;
		});
		extend('passwordCondition', (value: string): boolean | string => {
			let conditions: string[] = ['bigLetter', 'smallLetter', 'specialChar', 'number'];
			conditions = conditions.filter((condition: string) => regularExpressions[condition].test(value));
			if (conditions.length >= 2)
				return true;

			return i18n.t('message.createAccount.conditionsError') as string;
		});
		extend('passwordAllowedChars', (value: string): boolean | string => {
			if (regularExpressions.allowedPasswordCharacters.test(value))
				return true;

			return i18n.t('message.common.errors.wrongCharacterError') as string;
		});
		extend('bigLetter', (value: string): boolean | string => {
			if (regularExpressions.bigLetter.test(value))
				return true;

			return i18n.t('message.createAccount.bigLetter') as string;
		});
		extend('smallLetter', (value: string): boolean | string => {
			if (regularExpressions.smallLetter.test(value))
				return true;

			return i18n.t('message.createAccount.smallLetter') as string;
		});
		extend('specialChar', (value: string): boolean | string => {
			if (regularExpressions.specialChar.test(value))
				return true;

			return i18n.t('message.createAccount.specialChar') as string;
		});
		extend('number', (value: string): boolean | string => {
			if (regularExpressions.number.test(value))
				return true;

			return i18n.t('message.createAccount.number') as string;
		});
		extend('phone', (value: string): boolean | string => {
		  const phone = normalizePhone(value);
		  if (phone.startsWith('387') && !phone.startsWith('3870') && [12, 11].includes(phone.length))
		    return true;

		  return i18n.t('message.common.errors.phone') as string;
		});
		extend('simplePassword', (value: string): boolean | string => {
			if (value.length >= 6)
				return true;

			return i18n.t('message.tvToGo.form.passwordValidationMessage') as string;
		});
		extend('maxCarPlate', {
			validate(value) {
				return value.length <= 20;
			},
			message: i18n.t('message.parking.carLengthValidation') as string
		});

		configure({
			classes: {
				valid: 'valid',
				invalid: 'invalid'
			}
		});
	}
};
